import type { OptionState } from '@openx/types/options.ts';
import { useMemo } from 'react';
import { useOptionsByPathQuery } from '../../../hooks/useOptionsByPathQuery.ts';

export const useVideoPlacementOptionsFetch = ({ enabled }: { enabled: boolean }): OptionState => {
  const { data: { optionsByPath = [] } = {}, loading } = useOptionsByPathQuery({
    variables: {
      filter: { enabled },
      path: 'deal.package.targeting.video.video_plcmt',
    },
  });

  const list = useMemo(() => {
    if (!optionsByPath) {
      return [];
    }

    return optionsByPath.map(option =>
      option
        ? {
            id: option.id,
            name: option.name,
            ...option.extra,
          }
        : []
    );
  }, [optionsByPath]);

  const mapById = useMemo(() => {
    return list
      .map(option => ({ [option.id]: option }))
      .reduce((acc, curr) => {
        return Object.assign(acc, curr);
      }, {});
  }, [list]);

  return {
    list,
    loading,
    mapById,
  };
};
